<template>
  <div class="section">
    <div class="container" style="margin-top: -30px;">
      <b-field>
        <img :src="imageSrc1" alt="Laba" />
      </b-field>

      <b-field>
        <img :src="imageSrc2" alt="Laba" />
      </b-field>


      <b-field>
        <img :src="imageSrc3" alt="Laba" />
      </b-field>


      <b-field>
        <img :src="imageSrc4" alt="Laba" />
      </b-field>


      <b-field>
        <img :src="imageSrc5" alt="Laba" />
      </b-field>


      <b-field>
        <img :src="imageSrc6" alt="Laba" />
      </b-field>

     
      
    </div>  
  </div>
</template>

<script>
export default {
  name: "home",  
  
  data() {
    return {
      
    };
  },
  method: {
    
  },
  mounted() {
   
  },
  computed: {   
    // Using pathify

    imageSrc1() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/pages/event2024/agentda1.png'
        : 'http://localhost/lababiz/api/uploads/pages/event2024/agentda1.png';
    },

    imageSrc2() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/pages/event2024/agentda2.png'
        : 'http://localhost/lababiz/api/uploads/pages/event2024/agentda2.png';
    },

    imageSrc3() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/pages/event2024/agentda3.png'
        : 'http://localhost/lababiz/api/uploads/pages/event2024/agentda3.png';
    },

    imageSrc4() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/pages/event2024/agentda4.png'
        : 'http://localhost/lababiz/api/uploads/pages/event2024/agentda4.png';
    },

    imageSrc5() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/pages/event2024/agentda5.png'
        : 'http://localhost/lababiz/api/uploads/pages/event2024/agentda5.png';
    },

    imageSrc6() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/pages/event2024/agentda6.png'
        : 'http://localhost/lababiz/api/uploads/pages/event2024/agentda6.png';
    },

    
    lang() {
     
      return this.$store.get('switchLang') || 1;
    },
  },
};
</script>
